import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareWrenchIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 16 16' {...props}>
    <path
      d='M6.462 6.71L.586 12.586a2 2 0 002.828 2.828L9.29 9.538A5.52 5.52 0 016.462 6.71zM1.25 14a.75.75 0 101.5 0 .75.75 0 00-1.5 0z'
      fill='currentColor'
    />
    <path
      d='M12.471.105l.115.027c.284.071.384.424.177.63L10.44 3.086l.353 2.121 2.121.354 2.324-2.324a.375.375 0 01.629.172l.022.092a4.5 4.5 0 01-5.805 5.272.729.729 0 01-.007-.021l-.014.014a4.512 4.512 0 01-2.828-2.829l.02-.02-.027.002A4.5 4.5 0 0112.471.105z'
      fill='currentColor'
    />
  </SvgWrapper>
);
export const WrenchIcon = memo(BareWrenchIcon);
